import {
    SUPPORTCHAT_THREAD,SUPPORTCHAT_DETAILS,SUPPORTCHAT_USERDETAILS
} from "SupportChatAction";

// Local reducers for Support Chat thread
export var Chatthread = (state = {}, action) => {
    switch (action.type) {
      case SUPPORTCHAT_THREAD:
        return action.data;
      default:
        return state;
    }
};

// Local reducers for Support Chat thread Details [selected email]
export var ChatthreadDetails = (state = {}, action) => {
  switch (action.type) {
    case SUPPORTCHAT_DETAILS:
      return action.data;
    default:
      return state;
  }
};

// Local reducers for User Details [With Event ID & Email]
export var userDetailsWithEmail = (state = {}, action) => {
  switch (action.type) {
    case SUPPORTCHAT_USERDETAILS:
      return action.data;
    default:
      return state;
  }
};